var _rect, _rect2, _rect3, _rect4, _rect5, _line, _circle, _circle2, _circle3, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _line2, _line3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 556,
    height: 401,
    viewBox: "0 0 556 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 277,
    width: 556,
    height: 123,
    fill: "#030014"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 393,
    rx: 20,
    fill: "url(#paint0_linear_117_13337)",
    fillOpacity: 0.03
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 555,
    height: 392,
    rx: 19.5,
    stroke: "url(#paint1_linear_117_13337)",
    strokeOpacity: 0.08
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 536,
    height: 391,
    rx: 12,
    fill: "url(#paint2_linear_117_13337)",
    fillOpacity: 0.04
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 535,
    height: 390,
    rx: 11.5,
    stroke: "url(#paint3_linear_117_13337)",
    strokeOpacity: 0.12
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 198.5,
    y1: 10,
    x2: 198.5,
    y2: 401,
    stroke: "url(#paint4_linear_117_13337)",
    strokeOpacity: 0.12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 36,
    r: 4,
    fill: "white",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 36,
    r: 4,
    fill: "white",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 36,
    r: 4,
    fill: "white",
    fillOpacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 84,
    width: 144,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 66,
    width: 87.5351,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 84,
    width: 70.0281,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 102,
    width: 54.1623,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 324.006,
    y: 66,
    width: 38.8437,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 305.405,
    y: 84,
    width: 31.1844,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 288.445,
    y: 102,
    width: 24.6192,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 368.32,
    y: 66,
    width: 60.1804,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 340.966,
    y: 84,
    width: 48.1443,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 316.347,
    y: 102,
    width: 37.2024,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 433.972,
    y: 66,
    width: 21.8838,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 393.487,
    y: 84,
    width: 17.507,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 356.832,
    y: 102,
    width: 13.6774,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 461.326,
    y: 66,
    width: 42.6733,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 415.371,
    y: 84,
    width: 34.4669,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 373.792,
    y: 102,
    width: 26.8076,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 135,
    width: 87.5351,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 153,
    width: 70.0281,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 324.006,
    y: 135,
    width: 38.8437,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 305.405,
    y: 153,
    width: 38.2966,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 368.32,
    y: 135,
    width: 43.2204,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 349.172,
    y: 153,
    width: 59.0862,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 415.918,
    y: 135,
    width: 15.3186,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 413.729,
    y: 153,
    width: 21.8838,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 435.613,
    y: 135,
    width: 30.6373,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 440.537,
    y: 153,
    width: 42.6733,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 186,
    width: 87.5351,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 204,
    width: 70.0281,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 324.006,
    y: 186,
    width: 38.8437,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 305.405,
    y: 204,
    width: 31.1844,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 368.32,
    y: 186,
    width: 60.1804,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 340.966,
    y: 204,
    width: 48.1443,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 433.972,
    y: 186,
    width: 21.8838,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 393.487,
    y: 204,
    width: 17.507,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 461.326,
    y: 186,
    width: 42.6733,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 415.371,
    y: 204,
    width: 34.4669,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 237,
    width: 87.5351,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 255,
    width: 70.0281,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 324.006,
    y: 237,
    width: 38.8437,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 305.405,
    y: 255,
    width: 31.1844,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 368.32,
    y: 237,
    width: 60.1804,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 340.966,
    y: 255,
    width: 48.1443,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 433.972,
    y: 237,
    width: 21.8838,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 393.487,
    y: 255,
    width: 17.507,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 461.326,
    y: 237,
    width: 42.6733,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 415.371,
    y: 255,
    width: 34.4669,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 126,
    width: 144,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 168,
    width: 144,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.06
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 210,
    width: 144,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.04
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 252,
    width: 144,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.02
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 294,
    width: 144,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.01
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 336,
    width: 144,
    height: 30,
    rx: 8,
    fill: "url(#paint5_linear_117_13337)",
    fillOpacity: 0.01
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 59.5,
    x2: 198,
    y2: 59.5,
    stroke: "white",
    strokeOpacity: 0.12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 399.5,
    x2: 556,
    y2: 399.5,
    stroke: "url(#paint6_linear_117_13337)",
    strokeOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_13337",
    x1: 278,
    y1: 0,
    x2: 278,
    y2: 393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_117_13337",
    x1: 278,
    y1: 0,
    x2: 278,
    y2: 411.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_117_13337",
    x1: 278,
    y1: 10,
    x2: 278,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_117_13337",
    x1: 278,
    y1: 10,
    x2: 278,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_117_13337",
    x1: 198,
    y1: 401,
    x2: 198,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_117_13337",
    x1: 102,
    y1: 336,
    x2: 102,
    y2: 366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_117_13337",
    x1: 556,
    y1: 400,
    x2: 0,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.05772de3cf880634077d95fbe2b16f7c.svg";
export { ForwardRef as ReactComponent };